import React from 'react';
import { Instagram } from 'lucide-react';
import { instagramTiles, SITE } from '../data/mock';
import useReveal from '../hooks/useReveal';

const InstagramGrid = () => {
  const [headRef, headVisible] = useReveal();
  const [gridRef, gridVisible] = useReveal();
  return (
    <section className="bg-[#EDE3CF] py-24">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div ref={headRef} className={`reveal ${headVisible ? 'in' : ''} text-center mb-12`}>
          <p className="text-[11px] tracking-[0.32em] uppercase text-[#A07A4F] mb-3">— Real homes</p>
          <h2
            className="text-4xl md:text-5xl text-[#33200F]"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Tagged <span className="italic text-[#5B3A24]">#timberandthread</span>
          </h2>
          <a
            href="#"
            className="mt-5 inline-flex items-center gap-2 text-[12px] tracking-[0.22em] uppercase text-[#33200F] link-underline"
          >
            <Instagram className="h-4 w-4" strokeWidth={1.5} /> @{SITE.ig}
          </a>
        </div>

        <div
          ref={gridRef}
          className={`reveal-stagger ${gridVisible ? 'in' : ''} grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3`}
        >
          {instagramTiles.map((src, i) => (
            <a
              key={i}
              href="#"
              className="group relative aspect-square overflow-hidden bg-[#E3D5B8]"
            >
              <img
                src={src}
                alt=""
                className="w-full h-full object-cover image-zoom"
              />
              <div className="absolute inset-0 bg-[#1E140B]/0 group-hover:bg-[#1E140B]/40 transition-colors flex items-center justify-center">
                <Instagram
                  className="h-7 w-7 text-[#F5EDDD] opacity-0 group-hover:opacity-100 transition-opacity"
                  strokeWidth={1.4}
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstagramGrid;
